import { Slide } from '@features/powerpoint';
import { headerTextStyles } from '@features/lci-report/utils';
import { TITLE } from './section-title-slide-master';

export const sectionTitleSlide = (titleText: string): Slide => ({
  slideMaster: TITLE,
  texts: [
    {
      text: titleText,
      options: {
        fontSize: headerTextStyles.titleSlide.fontSize,
        color: headerTextStyles.titleSlide.color,
        bold: true,
        breakLine: true,
        h: 0.98,
        w: 5.1,
        x: 0.76,
        y: 4.17,
      },
    },
  ],
});
